import {
	removeInvestorFromMip,
	getAllInvestorData,
} from '@dealstack/frontend/shared/dataExchange/services/god.service';
import { logger } from '@dealstack/frontend/shared/mechanism/logger/logger';
import { useDSToast } from '@dealstack/frontend/shared/mechanism/toast/useDSToast';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export const useManageInvestor = () => {
	const toastAPI = useDSToast();
	const { investorId } = useParams();
	const getInvestorDataRequest = useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.GODMODE_INVESTOR_USERID_GET, { userId: investorId || '' }),
		],
		queryFn: ({ signal }) =>
			getAllInvestorData(
				formatUnicorn(API_PATHS.GODMODE_INVESTOR_USERID_GET, {
					userId: investorId || '',
				}),
				signal
			),
		meta: { suppressErrorToast: true },
	});

	const removeInvestorFromMipRequest = useMutation({
		mutationFn: removeInvestorFromMip,

		onSuccess: () => {
			toastAPI.success({});
			setInvestorIdToRemove(null);
			return getInvestorDataRequest.refetch();
		},

		onError: (error) => {
			toastAPI.error({});
			logger.error(error);
		},
	});

	const [investorIdToRemove, setInvestorIdToRemove] = useState<string | null>(null);

	return {
		investorIdToRemove,
		setInvestorIdToRemove,
		getInvestorDataRequest,
		removeInvestorFromMipRequest,
	};
};
